import React from "react";

import { HeaderBreadcrumbRoutes } from "../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { ProtectedRoute, RouteItem } from "../core/routing/ProtectedRoute";
import { SprintAccessRight } from "../core/security/SprintAccessRight";
import { OnPremOrderDashboard } from "./on-prem-orders/dashboard/OnPremOrderDashboard";
import { OnPremOrderListingDashboard } from "./on-prem-orders/listing/OnPremOrderListingDashboard";
import { CreateOrderPage } from "./orders/create/CreateOrderPage";
import { OrderDashboard } from "./orders/dashboard/OrderDashboard";
import { ImportOrdersForm } from "./orders/import/ImportOrdersForm";
import { OrderListingDashboard } from "./orders/listing/OrderListingDashboard";
import { OrderRequestDashboard } from "./requests/dashboard/OrderRequestDashboard";
import { OrderRequestListingDashboard } from "./requests/listing/OrderRequestListingDashboard";

const ordersBasePath = "/orders";

export const createOrderFormRoute: RouteItem = {
    path: `${ordersBasePath}/orders/create`,
    component: CreateOrderPage,
    accessRights: [SprintAccessRight.OrdReadWrite],
    name: "Create Order"
};

export const importOrderFormRoute: RouteItem = {
    path: `${ordersBasePath}/orders/import`,
    component: ImportOrdersForm,
    accessRights: [SprintAccessRight.OrdReadWrite],
    name: "Import Orders"
};

export const orderDashboardRoute: RouteItem = {
    path: `${ordersBasePath}/orders/order/:orderId`,
    component: OrderDashboard,
    accessRights: [SprintAccessRight.OrdRead],
    name: "Order"
};

export const orderListingRoute: RouteItem = {
    path: `${ordersBasePath}/orders`,
    component: OrderListingDashboard,
    accessRights: [SprintAccessRight.OrdRead],
    name: "Orders"
};

export const onPremOrderListingRoute: RouteItem = {
    path: `${ordersBasePath}/on-prem-orders`,
    component: OnPremOrderListingDashboard,
    accessRights: [SprintAccessRight.OrdReadWrite],
    name: "On-Prem Orders"
};

export const onPremOrderDashboardRoute: RouteItem = {
    path: `${ordersBasePath}/on-prem-orders/order/:orderId`,
    component: OnPremOrderDashboard,
    accessRights: [SprintAccessRight.OrdReadWrite],
    name: "On-Prem Order"
};

export const requestListingRoute: RouteItem = {
    path: `${ordersBasePath}/requests`,
    component: OrderRequestListingDashboard,
    accessRights: [SprintAccessRight.OrdRead],
    name: "Requests"
};

export const requestDashboardRoute: RouteItem = {
    path: `${ordersBasePath}/requests/request/:orderRequestId`,
    component: OrderRequestDashboard,
    accessRights: [SprintAccessRight.OrdRead],
    name: "Order request"
};

export const ordersRoutes: HeaderBreadcrumbRoutes = {
    routeItems: [
        createOrderFormRoute,
        importOrderFormRoute,
        orderListingRoute,
        orderDashboardRoute,
        onPremOrderListingRoute,
        requestListingRoute,
        requestDashboardRoute,
        onPremOrderDashboardRoute
    ],
    baseRouteNames: ["Orders"]
};

export const OrdersRoutes: React.FunctionComponent = () => {
    return (
        <>
            <ProtectedRoute protectedRouteData={createOrderFormRoute} />
            <ProtectedRoute protectedRouteData={importOrderFormRoute} />
            <ProtectedRoute protectedRouteData={orderListingRoute} />
            <ProtectedRoute protectedRouteData={orderDashboardRoute} />
            <ProtectedRoute protectedRouteData={onPremOrderListingRoute} />
            <ProtectedRoute protectedRouteData={requestListingRoute} />
            <ProtectedRoute protectedRouteData={requestDashboardRoute} />
            <ProtectedRoute protectedRouteData={onPremOrderDashboardRoute} />
        </>
    );
};

export const getOrderRequestDashboardHref = (orderRequestId: string): string => {
    return requestDashboardRoute.path.replace(":orderRequestId", orderRequestId);
};

export const getOrderDashboardHref = (orderId: string): string => {
    return orderDashboardRoute.path.replace(":orderId", orderId);
};

export const getOnPremOrderDashboardHref = (orderId: string): string => {
    return onPremOrderDashboardRoute.path.replace(":orderId", orderId);
};
